var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"over-pay"},[_c('a',{staticClass:"bg-r-btn",attrs:{"href":"javascript:;"},on:{"click":_vm.overpay}},[_vm._v("立即支付")])])}
var staticRenderFns = []

export { render, staticRenderFns }